/* eslint-disable no-unused-vars */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-shadow */
import React, { useEffect, useRef, useState } from 'react';
// eslint-disable-next-line no-unused-vars
import styled from 'styled-components/macro';
import { Marker, MarkerClusterer } from '@react-google-maps/api';
import campaignService from 'services/campaignService';
import style from './styles.json';
import storesService from '../../../services/storeService';
import GoogleMap from '../../molecules/GoogleMap';
import { GeoCode, ProvinceLatLng } from '../../../helpers/common';
import Toast from '../../molecules/Toast';
import userCities from '../../../helpers/cities.json';

function GoogleLocationSelector({ onChange = () => {}, value = {}, getImage = false, province = [], ...rest }) {
  const [marker, setMarker] = useState({});
  const [markers, setMarkers] = useState([]);
  const [max, setMax] = useState();

  const [markers_data, setMarkersData] = useState({
    provinces: [],
    cities: [],
    areas: [],
  });
  const [zoom, setZoom] = useState(4);
  const [address, setAddress] = useState({});
  const [centers, setCenters] = useState({
    lat: 51.0666293,
    lng: -114.0581756,
  });

  const map = useRef(null);
  // useEffect(() => {
  //   (async () => {
  //     const data = await campaignService.getPlastkUsersForMap();
  //     setMarkersData(prev => ({
  //       ...prev,
  //       provinces: data.provinceData,
  //       cities: data.cityData,
  //       areas: data.areaData,
  //     }));
  //     setMax(prev => ({ provinceMax: data.provinceMax, cityMax: data.cityMax, areaMax: data.areaMax }));
  //   })();
  // }, []);

  const interpolateValue = (value, maxValue) => {
    // Define the range of input values

    const minValue = 1;

    // Define the range of output values
    let minResult;
    let maxResult;
    if (maxValue > 1 && maxValue <= 100) {
      minResult = 10;
      maxResult = 40;
    } else if (maxValue > 100 && maxValue <= 500) {
      minResult = 10;
      maxResult = 60;
    } else if (maxValue > 500 && maxValue <= 800) {
      minResult = 20;
      maxResult = 80;
    } else {
      minResult = 20;
      maxResult = 100;
    }

    // Calculate the normalized value between 0 and 1
    const normalizedValue = (value - minValue) / (maxValue - minValue);

    // Interpolate the result using the normalized value
    const interpolatedResult = minResult + (maxResult - minResult) * normalizedValue;

    // Round the result to two decimal places
    return Math.round(interpolatedResult * 100) / 100;
  };

  // const getLocationOnMap = async (province = [], users = [], total = 0) => {
  //   const unique_struct = [];
  //   console.log({ zoom });

  //   let struct = users
  //     .map(({ province, citiesTotal }) => {
  //       const dat = userCities[province.toLowerCase()];
  //       let cities_data = [];
  //       if (dat) {
  //         cities_data = Object.entries(citiesTotal).map(([key, value]) => {
  //           let data = dat.find(({ city }) => city === key.toLowerCase());
  //           if (!data) {
  //             data = dat.find(({ city }) => key.toLowerCase().includes(city) || city.includes(key.toLowerCase()));
  //           }
  //           if (!data) {
  //             return { amount: 0 };
  //           }
  //           return { ...data, amount: value };
  //         });
  //       }
  //       return cities_data.filter(({ amount }) => amount > 0);
  //     })
  //     .flat();

  //   struct.forEach(el => {
  //     const index = unique_struct.findIndex(le => le.latitude === el.latitude && le.longitude === el.longitude);
  //     if (index === -1) {
  //       unique_struct.push(el);
  //     } else {
  //       unique_struct[index].amount += el.amount;
  //     }
  //   });
  //   struct = unique_struct;
  //   const _positions = [];
  //   for (const p of province) {
  //     _positions.push({
  //       position: ProvinceLatLng[p],
  //       label: users.find(({ province }) => province === p).total
  //         ? users.find(({ province }) => province === p).total
  //         : '0',
  //     });
  //   }
  //   setMarkersData({ cities: struct, provinces: _positions });
  //   setZoom(4);
  // };

  // useEffect(() => {
  //   campaignService
  //     .getCampaignProvince(province)
  //     .then(res => {
  //       getLocationOnMap(province, res.totalUsers, res?.allUsers);
  //     })
  //     .catch(err => {
  //       // console.log({ error: err.message });
  //     });
  // }, [province]);

  // useEffect(() => {
  //   if (value?.place_id && value.place_id !== address.place_id) {
  //     GeoCode({ placeId: value?.place_id })
  //       .then(res => {
  //         setMarker(res.latlng);
  //         setAddress(res);
  //         // eslint-disable-next-line no-unused-expressions
  //         getImage
  //           ? storesService.getImageFromPlaceId(res.place_id).then(img => {
  //               if (!img.image) {
  //                 Toast({
  //                   type: 'warning',
  //                   message: 'No Image Found On Google',
  //                 });
  //               }
  //               onChange({ target: { value: { ...res, image: img.image }, name: rest.name } });
  //             })
  //           : onChange({ target: { value: { ...res }, name: rest.name } });
  //       })
  //       .catch(() => {
  //         Toast({
  //           type: 'warning',
  //           message: 'Please Select A Valid Location',
  //         });
  //       });
  //   }
  // }, []);

  useEffect(() => {
    if (zoom > 6 && zoom <= 9) {
      setMarkers(
        markers_data.cities.map(({ lat, lng, count }, i) => (
          <Marker
            position={{
              lat: +lat,
              lng: +lng,
            }}
            // label={{
            //   text: String(count).toLowerCase(),
            //   color: '#ffffff',
            // }}
            key={i}
            icon={{
              path: window.google.maps.SymbolPath.CIRCLE,
              scale: interpolateValue(count, max.cityMax),
              color: '#ffffff',
              strokeColor: '#ff0000',
              strokeWeight: 1,
              fillColor: '#d82828',
              fillOpacity: 0.7,
            }}
          />
        )),
      );
    } else if (zoom > 9) {
      setMarkers(
        markers_data.areas.map(({ lat, lng, count }, i) => (
          <Marker
            position={{
              lat: +lat,
              lng: +lng,
            }}
            // label={{
            //   text: String(count).toLowerCase(),
            //   color: '#ffffff',
            // }}
            key={i}
            icon={{
              path: window.google.maps.SymbolPath.CIRCLE,
              scale: interpolateValue(count, max.areaMax),
              color: '#ffffff',
              strokeColor: '#ff0000',
              strokeWeight: 1,
              fillColor: '#d82828',
              fillOpacity: 0.7,
            }}
          />
        )),
      );
    } else {
      setMarkers(
        markers_data.provinces.map(({ lat, lng, count }, i) => (
          <Marker
            position={{
              lat: +lat,
              lng: +lng,
            }}
            // label={{
            //   text: String(count).toLowerCase(),
            //   color: '#ffffff',
            // }}
            key={i}
            icon={{
              path: window.google.maps.SymbolPath.CIRCLE,
              scale: interpolateValue(count, max.provinceMax),
              color: '#ffffff',
              strokeColor: '#ff0000',
              strokeWeight: 1,
              fillColor: '#d82828',
              fillOpacity: 0.7,
            }}
          />
        )),
      );
    }
  }, [zoom, markers_data, map.current]);

  const onLoad = React.useCallback(_ => {
    map.current = _;
  }, []);

  const onUnmount = React.useCallback(() => {
    map.current = null;
  }, []);
  return (
    <GoogleMap
      onZoomChanged={() => {
        setZoom(map.current?.getZoom());
      }}
      onClick={c => {
        setCenters({ lat: c.latLng.lat(), lng: c.latLng.lng() });
      }}
      markers={markers}
      zoom={4}
      center={centers}
      options={{
        componentRestrictions: {
          country: 'CA',
        },
        streetViewControl: false,
        clickableIcons: true,
        restriction: {
          latLngBounds: {
            north: 83.174035,
            south: 42.682435,
            west: -141.152344,
            east: -52.382813,
          },
          strictBounds: true,
        },
        styles: style,
      }}
      onLoad={onLoad}
      onUnmount={onUnmount}
      style={{
        width: '100%',
        height: '100%',
      }}
    />
  );
}
export default GoogleLocationSelector;
